import { InputHTMLAttributes, useRef } from 'react';

import {
  FormControl, InputBaseProps, InputLabelProps, TextField,
} from '@mui/material';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

interface InputFormTextFieldProps {
  label: string;
  fullWidth?: boolean;
  sx?: object;
  register?: UseFormRegisterReturn;
  errorField?: FieldError;
  errorSuffix?: string;
  helperText?: string;
  defaultValue?: string;
  required?: boolean;
  // shrinkLabel: Avoid when settings dynamicaly the value the problem
  // of overlapping the label and the value
  shrinkLabel?: boolean;
  placeholder?: string;
  type?: InputHTMLAttributes<unknown>['type'];
  multiline?: boolean;
  maxRows?: number;
  disabled?: boolean;
  onBlur?: InputBaseProps['onBlur'];
  autoComplete?: string;
}
function InputFormTextField({
  label,
  fullWidth,
  sx,
  register,
  errorField,
  errorSuffix = '',
  helperText,
  defaultValue,
  required,
  shrinkLabel,
  placeholder,
  type,
  multiline,
  maxRows,
  disabled,
  onBlur,
  autoComplete,
}: InputFormTextFieldProps) {
  const inputLabelProps: Partial<InputLabelProps> = {
    required: false, // Disable asterisk * on required
  };
  const textInputRef = useRef<HTMLDivElement | null>(null);
  if (shrinkLabel) {
    inputLabelProps.shrink = true;
  }
  return (
    <FormControl fullWidth={fullWidth} sx={sx}>
      <TextField
        label={label}
        InputLabelProps={inputLabelProps}
        placeholder={placeholder || (shrinkLabel ? label : undefined)}
        {...register}
        multiline={multiline}
        maxRows={maxRows}
        error={!!errorField}
        helperText={errorField?.message ? `${errorField?.message}${errorSuffix}` : helperText}
        defaultValue={defaultValue}
        required={required}
        type={type}
        disabled={disabled}
        onBlur={onBlur}
        autoComplete={autoComplete}
        inputRef={textInputRef}
        // For number disable change value by scrolling
        onWheel={() => textInputRef?.current?.blur()}
      />
    </FormControl>
  );
}

export default InputFormTextField;
